import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["percent", "customIndicatorStyles"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ProgressBar = function ProgressBar(_ref) {
  var percent = _ref.percent,
      customIndicatorStyles = _ref.customIndicatorStyles,
      rest = _objectWithoutProperties(_ref, _excluded);

  var width = useMemo(function () {
    if (percent > 100) {
      return 100;
    } else if (percent < 0) {
      return 0;
    } else {
      return percent;
    }
  }, [percent]);
  return /*#__PURE__*/_jsx(ProgressContainer, {
    customIndicatorStyles: customIndicatorStyles,
    children: /*#__PURE__*/_jsx(ProgressIndicator, _objectSpread({
      style: {
        width: "".concat(width, "%")
      }
    }, rest))
  });
};
export var ProgressContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "progress-bar__ProgressContainer",
  componentId: "sc-1sqe4cq-0"
})(["", " ", ""], {
  "height": "0.375rem",
  "width": "100%",
  "borderRadius": "2px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
}, function (_ref2) {
  var customIndicatorStyles = _ref2.customIndicatorStyles;
  return customIndicatorStyles;
});
export var ProgressIndicator = /*#__PURE__*/_styled.div.withConfig({
  displayName: "progress-bar__ProgressIndicator",
  componentId: "sc-1sqe4cq-1"
})(["", " ", ""], {
  "height": "0.375rem",
  "borderRadius": "2px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))"
}, function (_ref3) {
  var customStyles = _ref3.customStyles;
  return customStyles;
});